import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { useGlobalModals } from "@/app/providers/modal-provider"

/**
 * Fraud-warning modal repeated (with drifting markup) on every legacy page
 * (migration plan §1.3/§5). Consolidated here as a single source of truth,
 * triggered from the footer on every route via useGlobalModals().
 */
export function CautionModal() {
  const { cautionOpen, closeCaution } = useGlobalModals()

  return (
    <Dialog open={cautionOpen} onOpenChange={(open) => !open && closeCaution()}>
      <DialogContent
        className="max-w-3xl"
        aria-labelledby="caution-modal-title"
      >
        <DialogHeader>
          <DialogTitle id="caution-modal-title">Caution Notice</DialogTitle>
          <DialogDescription asChild>
            <div className="space-y-3 text-sm text-text-strong">
              <p>
                It has come to our notice that certain individuals / persons claiming to be
                representatives of Reliance Foundation are deceiving / misleading the public by
                fraudulently collecting / soliciting monies in the form of deposits or otherwise,
                for purported scholarships and other educational benefits by Reliance Foundation.
              </p>
              <p>
                We hereby caution and notify the public that Reliance Foundation and its
                associated entities have neither appointed nor authorised any person or agency to
                offer such scholarships, or to issue any letters or to act on our behalf. Any such
                persons or agencies misleading the public are in no way connected to and do not
                represent Reliance Foundation or any of its associated entities.
              </p>
              <p>
                Reliance Foundation follows a formal selection process to offer scholarships, the
                details of which can be found on its official website. Reliance Foundation and its
                associated entities never solicit or accept monies by way of deposits or otherwise
                to offer any scholarship or other benefits. Members of the public are advised not
                to deal with such unscrupulous persons or fall prey to such fraudulent activities.
              </p>
              <p>
                Anyone dealing with fraudulent scholarship calls or communications would be doing
                so at their own risk. Reliance Foundation and its associated entities will not be
                responsible or liable in any manner whatsoever for any loss suffered directly or
                indirectly as a result of dealing with or depositing money with any such persons.
              </p>
              <p>
                We request you to promptly notify the local law enforcement authorities and
                simultaneously write to us at{" "}
                <a
                  href="mailto:rf.scholarships@reliancefoundation.org"
                  className="font-medium text-brand-teal underline"
                >
                  rf.scholarships@reliancefoundation.org
                </a>{" "}
                in case you come across any such fraudulent incident or have any information
                regarding solicitation for purported offer of scholarships or benefits in the name
                of Reliance Foundation or its associated entities
              </p>
            </div>
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  )
}
